import {type IAsset} from '../schema';
import {consituentClipsEnabled} from '@netx/core-constituents/enablers';
import {isVideoFileTypeAsset} from '../utils';

export const assetHasConstituentClips = (asset?: IAsset): asset is IAsset => {
	return (
		!!asset &&
		consituentClipsEnabled() &&
		isVideoFileTypeAsset(asset.fileFormatFamily)
	);
};
